import { render, staticRenderFns } from "./ShopKeyword.vue?vue&type=template&id=9c968f70&"
import script from "./ShopKeyword.vue?vue&type=script&lang=js&"
export * from "./ShopKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports